import { API_BASE_URL } from '@/lib/api';

/**
 * Resolve the image on a CMS record to a URL a browser can load.
 *
 * Content models name their image differently depending on when they were
 * added - background_image_url, image_url, image, cover_image_url,
 * cover_image, background_image - and the serializer may return either an
 * absolute URL or a path relative to the API host. This picks whichever is
 * present and makes a relative path absolute.
 *
 * Three pages carry their own inline copy of this. They are identical in
 * behaviour; this is the one new code should import.
 */
export function resolveMediaUrl(item: any): string {
  if (!item) return '';

  const url =
    item.background_image_url ||
    item.image_url ||
    item.image ||
    item.cover_image_url ||
    item.cover_image ||
    item.background_image ||
    '';

  // A path like /media/... is relative to the API host, not the site.
  if (url && url.startsWith('/') && !url.startsWith('//')) {
    return `${API_BASE_URL}${url}`;
  }

  return url;
}
